// extracted by mini-css-extract-plugin
export default {"checkbox":"MQ1GyzYA","indicator":"a9LIT5J5"};